import ActionTypes from '../constants/ActionTypes';
import { supo } from '../api';
import { areRecommendationsLoaded } from '../selectors/recommendations';

export const fetchRecommendations = id => {
  return async (dispatch, getState) => {
    if (areRecommendationsLoaded(getState(), id)) return;
    try {
      dispatch({
        type: ActionTypes.FETCH_RECOMMENDATIONS_SUCCESS,
        payload: { id }
      });
      const { data } = await supo.get(`/recommendations/${id}`);
      return dispatch({
        type: ActionTypes.FETCH_RECOMMENDATIONS_SUCCESS,
        payload: { id, recommendations: data }
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_RECOMMENDATIONS_NOT_FOUND,
          payload: { id },
          error
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_RECOMMENDATIONS_ERROR,
        payload: { id },
        error
      });
    }
  };
};
